module.exports = __webpack_public_path__ + "static/media/card_2x.21b1a9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/dallas/card_2x.jpg
// module id = 915
// module chunks = 27